'use client'

import * as ProgressPrimitive from '@radix-ui/react-progress'
import * as React from 'react'

import { cn } from '@/utils/shadcn/utils'

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    completedColor?: string
    remainingColor?: string
  }
>(({ className, value, completedColor, remainingColor, ...props }, ref) => {
  const getColorStyle = (color?: string) => {
    if (!color) return undefined
    return color.startsWith('#') ? color : `bg-${color}`
  }

  const completedColorStyle = getColorStyle(completedColor)
  const remainingColorStyle = getColorStyle(remainingColor)

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-moment-white-200 dark:bg-moment-blue-grey-1000',
        remainingColorStyle?.startsWith('bg-') && remainingColorStyle,
        className,
      )}
      style={
        remainingColorStyle?.startsWith('#')
          ? { backgroundColor: remainingColorStyle }
          : undefined
      }
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          'h-full w-full flex-1 transition-transform duration-500 ease-in-out bg-moment-green-800',
          completedColorStyle?.startsWith('bg-') && completedColorStyle,
        )}
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
          ...(completedColorStyle?.startsWith('#') && {
            backgroundColor: completedColorStyle,
          }),
        }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
